import RealtimeAlertingContainer from "./container/RealtimeAlertingContainer";

export default RealtimeAlertingContainer